import SectionPreview from "../../common/components/SectionPreview";

type CorrectionReasonProps = {
  note?: string;
};

const CorrectionReason = ({ note }: CorrectionReasonProps) => {
  return <SectionPreview title="Забележка (причини за извършване на корекцията):">{note}</SectionPreview>;
};

export default CorrectionReason;
